export default __webpack_public_path__ + "static/media/lobbey3.b4fa8462.jpg";